import { render, staticRenderFns } from "./shop-delete-dialog.vue?vue&type=template&id=75fb988f"
import script from "./shop-delete-dialog.vue?vue&type=script&lang=js"
export * from "./shop-delete-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports